


import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { RouteNames } from '@/utils/router/router.models';

@Component({})
export default class SummaryInfo extends Vue {
  @Prop({}) headline!: string;
  @Prop({}) description!: string;
  @Prop({}) navName!: string;
  @Prop({}) navLabel!: string;
  @Prop({ default: true }) renderActions!: boolean;
  @Prop({ default: false }) showOverscroll!: boolean;
  @Prop({ default: false }) invertScrollControl!: boolean;

  private RouteNames: typeof RouteNames = RouteNames;

  @Emit()
  public scroll() {
    return null;
  }
}
